import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import axios from "axios";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Modal from "react-modal";

const localizer = momentLocalizer(moment);

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};
Modal.setAppElement("#root");

export default function EventTable() {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [events, setEvents] = useState([]);
  const [modalData, setmodalData] = useState({});
  let changedEvents = [];
  useEffect(async () => {
    console.log("inital render");
    const result = await axios.get("https://anhrey.deta.dev/event/");
    console.log(result.data);
    for (let i = 0; i < result.data.length; i++) {
      // change date , start and endtime
      let newObject = {};
      console.log(result.data[i]);
      let changed = result.data[i].Date.split("-");
      console.log(changed);
      let year = parseInt(changed[0]);
      let month = parseInt(changed[1] - 1);
      let day = parseInt(changed[2]);

      console.log(year, month, day);

      let splitByspace = result.data[i].startTime.split(" ")[0].split(":");
      let startTimeHour = parseInt(splitByspace[0]);
      console.log(startTimeHour);
      let startTimeminutes = parseInt(splitByspace[1]);
      console.log(startTimeminutes);

      let splitnewByspace = result.data[i].endTime.split(" ")[0].split(":");
      let endTimeHour = parseInt(splitnewByspace[0]);

      let endTimeminutes = parseInt(splitByspace[1]);

      newObject.title = result.data[i].name;
      console.log(newObject);
      newObject.start = new Date(
        year,
        month,
        day,
        startTimeHour,
        startTimeminutes
      );
      newObject.end = new Date(year, month, day, endTimeHour, endTimeminutes);
      console.log(newObject);

      changedEvents.push(newObject);

      console.log(changedEvents, "changedEvent");
      await setEvents(changedEvents);
    }
  }, []);

  console.log(events, "event outside");
  const handleEventSelection = (e) => {
    console.log(e, "modaldata");
    setIsOpen(!modalIsOpen);

    setmodalData(e);
  };

  const changeDate = (date) => {
    console.log(date);
    return date.toString();
  };
  const closeModal = () => {
    setIsOpen(!modalIsOpen);
    setmodalData({});
  };
  return (
    <div className="EventTable">
      <Modal
        isOpen={modalIsOpen}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h2>{modalData ? modalData.title : ""}</h2>
        <p>from : {modalData.start ? changeDate(modalData.start) : ""}</p>
        <p>to : {modalData.end ? changeDate(modalData.end) : ""}</p>
        <button class="btn" onClick={closeModal}>
          Close
        </button>
      </Modal>
      {events.length > 0 ? (
        <Calendar
          localizer={localizer}
          events={events}
          step={60}
          defaultView="week"
          views={["week"]}
          onSelectEvent={handleEventSelection}
          style={{ height: 1000, width: 1000 }}
        />
      ) : (
        <div>Loading.....</div>
      )}
    </div>
  );
}
